import { useQuery } from "relay-hooks";
import { graphql } from "babel-plugin-relay/macro";
import { grammarExplanationQuery } from "./__generated__/grammarExplanationQuery.graphql";
import { AssistantMode } from "./__generated__/chatIdeasMutation.graphql";

const GrammarExplanationQuery = graphql`
  query grammarExplanationQuery(
    $text: String!
    $correctedText: String!
    $language: String
    $responseLanguage: String
    $mode: AssistantMode
    $context: String
  ) {
    grammarExplanation(
      text: $text
      correctedText: $correctedText
      language: $language
      responseLanguage: $responseLanguage
      context: $context
      mode: $mode
    )
  }
`;

type UseGrammarExplanationArgs = {
  text?: string;
  correctedText?: string;
  language?: string;
  responseLanguage?: string;
  mode?: AssistantMode;
  context?: string;
};

export const useGrammarExplanation = (args: UseGrammarExplanationArgs) => {
  const shouldSkip = !args.text || !args.correctedText;
  const { data, error, isLoading, retry } = useQuery<grammarExplanationQuery>(
    GrammarExplanationQuery,
    {
      text: args.text || "",
      correctedText: args.correctedText || "",
      language: args.language || null,
      responseLanguage: args.responseLanguage || null,
      mode: args.mode || null,
      context: args.context || null
    },
    { skip: shouldSkip }
  );

  return {
    explanation: shouldSkip ? undefined : data?.grammarExplanation,
    error,
    isLoading,
    retry
  };
};
